<template><div><h1 id="ereignis-esr-nummerverknupfungen" tabindex="-1"><a class="header-anchor" href="#ereignis-esr-nummerverknupfungen"><span>Ereignis-ESR-Nummerverknüpfungen</span></a></h1>
<p>Ereignis-ESR-Nr. Verknüpfung — Definiert zulässige Ereignis-ESR-Nr. Verknüpfungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert zulässige Ereignis-ESR-Nr. Verknüpfungen. Beim Einsatz von Fremdwährungen ist zu definieren welche ESR-Nummern für welche Ereignisse zulässig sind.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Ereignis-QR-/ESR-Rechnungsverbindungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Whg</dt>
<dd>Kürzel für die Währungsbezeichnung, siehe <a class="link" href="ft.refdata.whg.html" title="Währung">Währung</a></dd>
<dt>Ereignis</dt>
<dd>Ereignisnummer, siehe <a class="link" href="../../manual/customer/ereignisse-und-ereignispositionen.html" title="4. Ereignisse">Ereignisse-und-Ereignispositionen</a></dd>
<dt>ESRnr</dt>
<dd>ESR-Nummer, siehe <a class="link" href="ft.refdata.tblesr.html" title="QR-/ESR-Rechnunsgparameter">QR-/ESR-Rechnunsgparameter</a></dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


